export default __webpack_public_path__ + "static/media/image11.7035aff0.png";